import React from 'react';
import cn from 'classnames';

import styles from './ProviderLogo.module.scss';

export const ProviderLogo = ({ path, className }: { path: string; className?: string }) => {
  return <img className={cn(className, styles.providerLogo)} src={path} alt='provider logo' />;
};
